export default "__VITE_ASSET__BsnXpepy__"